import React from 'react';
import { DatePicker } from 'antd';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";
import moment from 'moment'
export default class DateTimeEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(value) {
        this.props.source.value = value.valueOf();
        this.setState({});
    }
    onOk(value) {
        this.props.source.value = value.valueOf();
    }
    render() {
        let value = this.props.source.value
        return (
            <DatePicker style={{ minWidth: "100%" }} defaultValue={moment(value)} showTime allowClear={false}
                onOk={this.onOk.bind(this)} onChange={this.onChange.bind(this)}
                placeholder={this.props.source.placeholder} />
        );
    }
}

PropertyGridUtils.register("datetime", (source, propertyGrid) => <DateTimeEditor source={source} propertyGrid={propertyGrid} />);